// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3WK2a","info":"Note_info__pJ0D9","note":"Note_note__3NT8z","actions":"Note_actions__3-98X"};